import $ from 'jquery';


$( '.instagram-block__slider' ).slick( {
	dots: false,
	infinite: true,
	slidesToShow: 5,
	centerMode: false,
	speed: 300,
	arrows: true,
	responsive: [ {
		breakpoint: 3000,
	}, {
		breakpoint: 1024,
		settings: {
			variableWidth: false,
			slidesToShow: 3,
		},
	}, {
		breakpoint: 640,
		settings: {
			variableWidth: false,
			slidesToShow: 1,
		},
	} ]
} );

$( '.instagram-block__modal-slider' ).slick( {
	dots: false,
	infinite: true,
	slidesToShow: 1,
	centerMode: false,
	speed: 300,
	arrows: true,
} );

$( '.pinterest-block__modal-slider' ).slick( {
	dots: false,
	infinite: true,
	slidesToShow: 1,
	centerMode: false,
	speed: 300,
	arrows: true,
} );


$( '.content-slider__slide[data-slide]' ).click( function ( e ) {
	e.preventDefault();
	var slideno = $( this ).data( 'slide' );
	$( '.instagram-block__modal-slider' ).slick( 'slickGoTo', slideno - 1 );
} );

$( '.pinterest-slide[data-slide]' ).click( function ( e ) {
	e.preventDefault();
	var slideno = $( this ).data( 'slide' );
	$( '.pinterest-block__modal-slider' ).slick( 'slickGoTo', slideno - 1 );
} );